import { render } from "./index.vue?vue&type=template&id=4f4a3f48&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4f4a3f48&scoped=true&lang=css"

import exportComponent from "/data/zlj/zlj/zlj-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4a3f48"]])

export default __exports__